import { aciesDateFormat } from '@shared/helpers';

/** An epoch-ms time as One Monitor shows it, or a dash when there is none. */
export function formatEpoch(ms: number | null | undefined): string {
	return ms != null ? aciesDateFormat(new Date(ms), true, true) : '—';
}
